const BERTH_TO_BERTH_LOCATIONS_WITH_VESSEL_DETAIL_FIELDS = new Set(["FOTT", "VPK"]);

type RadioButtonParams = {
  movementType: string;
  fromLocation: string;
  toLocation: string;
};

export const shouldShowVesselDetailRadioButtons = ({
  movementType,
  fromLocation,
  toLocation,
}: RadioButtonParams): boolean => {
  if (!movementType) return false;

  const isEligibleBerthToBerthDestination =
    BERTH_TO_BERTH_LOCATIONS_WITH_VESSEL_DETAIL_FIELDS.has(toLocation);

  return (
    (movementType === "BERTH_TO_ANCHORAGE" && fromLocation === "FOTT") ||
    (movementType === "BERTH_TO_SEA" && fromLocation === "FOTT") ||
    (movementType === "SEA_TO_BERTH" && toLocation === "FOTT") ||
    (movementType === "ANCHORAGE_TO_BERTH" && toLocation === "FOTT") ||
    (movementType === "BERTH_TO_BERTH" && isEligibleBerthToBerthDestination)
  );
};
